import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textAreaInput", "submitButton"]
  static values = {
    url: String
  }

  connect() {
    // console.log("Hello from the DraftModificationController connected")
    // console.log(this.urlValue);
    // console.log(this.textAreaInputTarget.value);
  }

  loadShortcut(event) {
    // console.log("Loading shortcut");
    this.textAreaInputTarget.value = event.target.dataset.text;
  }

  submit(event) {
    event.preventDefault()
    // console.log("Form submitted");
    // console.log(this.textAreaInputTarget.value)
    // console.log(this.urlValue);

    this.submitButtonTarget.setAttribute('disabled', true);
    this.submitButtonTarget.innerText = 'Modifying...';

    fetch(this.urlValue, {
      method: 'POST',
      body: JSON.stringify({ modification: this.textAreaInputTarget.value }),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      // console.log(data);

      if (data.status === 200) {
        document.cookie = `flash_notice=Draft was successfully modified; path=/`;
        window.location.reload();
      } else {
        console.error('Error:', data.error);
        createAlert('danger', 'There was an error modifying the recap');
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

}